import React, {Component} from 'react'
import ls from 'local-storage'

import Header from '../components/Header'
import Footer from '../components/Footer'
import Cart from '../components/Cart'

class Checkout extends Component {
    static getDerivedStateFromProps(nextProps, prevState) {
        if (nextProps.match.params.id !== prevState.id) {
            return {
                data: {},
                id: nextProps.match.params.id
            };
        }
        return null;
    }

    constructor(props) {
        super(props);
        this.state = {
            id: null,
            order_id: null,
            omiseToken: null,
            cart: {id: null, total: 0, products: []},
            form: {last_name: '', first_name: '', last_name_kana: '', first_name_kana: '', email: '', phone: '', method: ''},
            button_text: 'サシイレする',
            button_style: {}
        };
        this.handleChange = this.handleChange.bind(this);
    }

    componentDidMount() {
        const {OmiseCard} = window;
        OmiseCard.configure({
            publicKey: 'pkey_5d2ji370or2bnnbeuk4',
            //publicKey: 'pkey_test_5cuq1b6ex3nard40egn',
            currency: 'jpy'
        });

        this.setStateCartByLocalStorage();
    }

    componentDidUpdate(prevProps, prevState) {
        if (this.state.id !== prevState.id) {
            this.setStateCartByLocalStorage();
        }
    }

    handleChange(e) {
        let form = this.state.form;
        let name = e.target.name;
        if(name=='methodsp'){
            name='method'
        }
        form[name] = e.target.value;
        this.setState({form: form});
    }

    send = () => {
        this.setState({button_text: '送信中', button_style: {'pointer-events': 'none', opacity: 0.5}});
        let form = this.state.form;
        let products = this.state.cart.products;
        let api = process.env.REACT_APP_API_URL + '/order?key=' + process.env.REACT_APP_API_KEY;
        const method = "POST";
        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8'
        };
        let body = Object.keys(form).map((key)=>key+"="+encodeURIComponent(form[key])).join("&");
        for(let i in products){
            body += '&product_id['+i+']='+products[i].id+'&product_number['+i+']='+products[i].num;
        }
        body += '&club_id='+this.state.id;
        fetch(api, {method,headers,body}).then((response) => response.json()).then((responseJson) => {
            console.log(responseJson);
            if( responseJson.id ){
                if(form['method']=='bank'){
                    alert('サシイレのご注文が完了しました！\nメールの案内に従い銀行振込を行ってください。');
                    ls.clear();
                    this.props.history.push('/club/'+this.state.id);
                } else {
                    this.omiseOpen(responseJson.id);
                }
            } else {
                //エラー時
                let message = responseJson.message+'\n';
                for(let k in responseJson.error_a){
                    message += '\n'+responseJson.error_a[k];
                }
                alert(message);
            }
            this.setState({button_text: 'サシイレする', button_style: {'pointer-events': '', opacity: 1}});
        });
    };

    omiseOpen(id){
        const {OmiseCard} = window;
        OmiseCard.configure({
            amount: this.state.cart.total
        });
        OmiseCard.open({
            frameLabel: 'サシイレ',
            frameDescription: 'Order #'+id,
            amount: this.state.cart.total,
            onCreateTokenSuccess: (token) => {
                /* Your code, e.g., submit form or send ajax request to server */
                this.charge(id, token);
                this.setState({order_id:id, omiseToken:token});
            },
            onFormClosed: function() {
                /* Your handler when form was closed */
                //alert('closed');
            },
        })
    }

    charge(id, token){
        let api = process.env.REACT_APP_API_URL + '/charge?key=' + process.env.REACT_APP_API_KEY;
        const method = "POST";
        const headers = {
            'Accept': 'application/json',
            'Content-Type': 'application/x-www-form-urlencoded; charset=utf-8',
        };
        let post = {id: id, token: token};
        let body = Object.keys(post).map((key)=>key+"="+encodeURIComponent(post[key])).join("&");
        fetch(api, {method,headers,body}).then((response) => response.json()).then((responseJson) => {
            console.log(responseJson);
            if( responseJson.status=='success' ){
                alert('サシイレのご注文が完了しました！');
                ls.clear();
                this.props.history.push('/club/'+this.state.id);
            } else {
                alert('エラーが発生しました。');
            }
        });
    }

    setStateCartByLocalStorage() {
        let cart = ls.get('cart');
        if (this.state.id != cart.id) {
            cart = {id: null, total: 0, products: []};
        }
        this.setState({cart: cart});
    }

    render() {
        return (
            <div>
                <Header/>
                <div className="title-partslist-page">
                    購入画面
                </div>
                <div className="img-three-dot">
                    <img src="/images/three-dot.png" className="img-fluid"/>
                </div>
                <div className="content partslist-page">
                    <div className="container">
                        <div className="h2-tag-parts">
                            <img src="/images/icon_03.png" className="img-fluid mr-3"/>
                            <span>購入フォーム</span>
                        </div>
                        <div className="table-parts-page pt-3">
                            <table className="table table-parts">
                                <tbody>
                                <tr>
                                    <td className="td-custom-parts">
                                        <div className="clearfix">
                                            <div className="float-left">
                                                名前
                                            </div>
                                            <div className="float-right">
                                                <img src="/images/icon_08.png" className="img-fluid"/>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="td-right-parts">
                                            <div className="formgroup-parts-1">
                                                <div className="clearfix form-group">
                                                    <div className="float-left">
                                                        <div className="clearfix">
                                                            <div className="float-left text-control-1">
                                                                姓
                                                            </div>
                                                            <div className="float-right">
                                                                <input type="text" name="last_name"
                                                                       className="form-control form-input-1"
                                                                       value={this.state.form.last_name} onChange={this.handleChange}
                                                                       placeholder="さしいれ"/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="float-right">
                                                        <div className="clearfix">
                                                            <div className="float-left text-control-1">
                                                                名
                                                            </div>
                                                            <div className="float-right">
                                                                <input type="text" name="first_name"
                                                                       className="form-control form-input-1"
                                                                       value={this.state.form.first_name} onChange={this.handleChange}
                                                                       placeholder="太郎"/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="clearfix form-group">
                                                    <div className="float-left">
                                                        <div className="clearfix">
                                                            <div className="float-left text-control-2">
                                                                セイ
                                                            </div>
                                                            <div className="float-right">
                                                                <input type="text" name="last_name_kana"
                                                                       className="form-control form-input-1"
                                                                       value={this.state.form.last_name_kana} onChange={this.handleChange}
                                                                       placeholder="サシイレ"/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="float-right">
                                                        <div className="clearfix">
                                                            <div className="float-left text-control-2">
                                                                メイ
                                                            </div>
                                                            <div className="float-right">
                                                                <input type="text" name="first_name_kana"
                                                                       className="form-control form-input-1"
                                                                       value={this.state.form.first_name_kana} onChange={this.handleChange}
                                                                       placeholder="タロウ"/>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="td-custom-parts">
                                        <div className="clearfix">
                                            <div className="float-left">
                                                電話番号
                                            </div>
                                            <div className="float-right">
                                                <img src="/images/icon_08.png" className="img-fluid"/>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="form-group">
                                            <input type="text" name="phone" className="form-control form-input-3"
                                                   value={this.state.form.phone} onChange={this.handleChange}
                                                   placeholder="000-0000-0000"/>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="td-custom-parts">
                                        <div className="clearfix">
                                            <div className="float-left">
                                                メールアドレス
                                            </div>
                                            <div className="float-right">
                                                <img src="/images/icon_08.png" className="img-fluid"/>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="form-group">
                                            <input type="text" name="email" className="form-control form-input-3"
                                                   value={this.state.form.email} onChange={this.handleChange}
                                                   placeholder="info@sashiire.jp"/>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="td-custom-parts">
                                        <div className="clearfix">
                                            <div className="float-left">
                                                お支払い方法
                                            </div>
                                            <div className="float-right">
                                                <img src="/images/icon_08.png" className="img-fluid"/>
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="clearfix ml-2">
                                            <div className="float-left">
                                                <label className="label-radio mr-4">
                                                    <input name="method" type="radio"
                                                           checked={this.state.form.method=='credit'}
                                                           value="credit" onChange={this.handleChange}/>
                                                    <span className="checkmark"></span>
                                                    クレジットカード
                                                </label>
                                            </div>
                                            <div className="float-left ml-4 form-check">
                                                <label className="label-radio">
                                                    <input name="method" type="radio"
                                                           checked={this.state.form.method=='bank'}
                                                           value="bank" onChange={this.handleChange}/>
                                                    <span className="checkmark"></span>
                                                    銀行振込
                                                </label>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="td-custom-parts">
                                        <div className="clearfix">
                                            <div className="float-left">
                                                応援メッセージ
                                            </div>
                                        </div>
                                    </td>
                                    <td>
                                        <div className="textarea">
                                            <textarea name="message" className="form-control" rows="6" value={this.state.form.message} onChange={this.handleChange}></textarea>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                            <table className="table table-parts-mb">
                                <tbody>
                                <tr>
                                    <td className="td-custom-parts-mb">
                                        <div className="clearfix">
                                            <div className="float-left">
                                                名前
                                            </div>
                                            <div className="float-right">
                                                <img src="/images/icon_08.png" className="img-fluid"/>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="clearfix">
                                            <div className="float-left text-control-mb-1">
                                                姓
                                            </div>
                                            <div className="float-right form-input-mb-1">
                                                <input type="text" name="last_name" className="form-control"
                                                       value={this.state.form.last_name} onChange={this.handleChange}
                                                       placeholder="テキストテキスト"/>
                                            </div>
                                        </div>
                                        <div className="clearfix mt-3">
                                            <div className="float-left text-control-mb-1">
                                                名
                                            </div>
                                            <div className="float-right form-input-mb-1">
                                                <input type="text" name="first_name" className="form-control"
                                                       value={this.state.form.first_name} onChange={this.handleChange}
                                                       placeholder="テキストテキスト"/>
                                            </div>
                                        </div>
                                        <div className="clearfix mt-3">
                                            <div className="float-left text-control-mb-1">
                                                セイ
                                            </div>
                                            <div className="float-right form-input-mb-1">
                                                <input type="text" name="last_name_kana" className="form-control"
                                                       value={this.state.form.last_name_kana} onChange={this.handleChange}
                                                       placeholder="テキストテキスト"/>
                                            </div>
                                        </div>
                                        <div className="clearfix mt-3">
                                            <div className="float-left text-control-mb-1">
                                                メイ
                                            </div>
                                            <div className="float-right form-input-mb-1">
                                                <input type="text" name="first_name_kana" className="form-control"
                                                       value={this.state.form.first_name_kana} onChange={this.handleChange}
                                                       placeholder="テキストテキスト"/>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="td-custom-parts-mb">
                                        <div className="clearfix">
                                            <div className="float-left">
                                                電話番号
                                            </div>
                                            <div className="float-right">
                                                <img src="/images/icon_08.png" className="img-fluid"/>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="form-group formgroup-mb-parts-3 mt-3">
                                            <input type="text" name="phone" className="form-control form-input-3"
                                                   value={this.state.form.phone} onChange={this.handleChange}
                                                   placeholder="000-0000-0000"/>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="td-custom-parts-mb">
                                        <div className="clearfix">
                                            <div className="float-left">
                                                メールアドレス
                                            </div>
                                            <div className="float-right">
                                                <img src="/images/icon_08.png" className="img-fluid"/>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="form-group formgroup-mb-parts-3 mt-3">
                                            <input type="text" name="email" className="form-control form-input-3"
                                                   value={this.state.form.email} onChange={this.handleChange}
                                                   placeholder="info@sashiire.jp"/>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="td-custom-parts">
                                        <div className="clearfix">
                                            <div className="float-left">
                                                お支払い方法
                                            </div>
                                            <div className="float-right">
                                                <img src="/images/icon_08.png" className="img-fluid"/>
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="form-check">
                                            <label className="label-radio mr-4">
                                                <input name="methodsp" type="radio" value="credit"
                                                       checked={this.state.form.method=='credit'}
                                                       onChange={this.handleChange}/>
                                                <span className="checkmark"></span>
                                                クレジットカード
                                            </label>
                                        </div>
                                        <div className="form-check">
                                            <label className="label-radio">
                                                <input name="methodsp" type="radio" value="bank"
                                                       checked={this.state.form.method=='bank'}
                                                       onChange={this.handleChange}/>
                                                <span className="checkmark"></span>
                                                銀行振込
                                            </label>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td className="td-custom-parts-mb">
                                        <div className="clearfix">
                                            <div className="float-left">
                                                応援メッセージ
                                            </div>
                                        </div>
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div className="textarea">
                                            <textarea name="message" className="form-control" rows="6" value={this.state.form.message} onChange={this.handleChange}></textarea>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <Cart cart={this.state.cart} readOnly={true}/>
                <div className="content partslist-page">
                    <div className="container">
                        <div className="div-btn-confirm-partslist py-3">
                            <a className="button-confirm-partslist" onClick={this.send} style={this.state.button_style}>{this.state.button_text}</a>
                        </div>
                    </div>
                </div>
                <Footer/>
            </div>
        )
    }
}

export default Checkout